export const POST_FUNNEL_EVENTS_REQUEST = 'POST_FUNNEL_EVENTS_REQUEST';
export const POST_FUNNEL_EVENTS_SUCCESS = 'POST_FUNNEL_EVENTS_SUCCESS';
export const POST_FUNNEL_EVENTS_FAILURE = 'POST_FUNNEL_EVENTS_FAILURE';
